export { default as createSurvey } from './create-survey.webp';
export { default as takeSurvey } from './take-survey.webp';
